
import { Checkbox, Collapse, FormControlLabel } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import {useTranslation} from "react-i18next";
import { pairingPackageInitialFilter } from '../../pages/PairingPackage/pairingPackageHelper';
import { useFilterPreference } from '../../providers/FilterPreference';

// import the scss styling
import './FilterContainer.scss';

export default function FilterContainer(props) {
    const { isOpen, handleClick, filterName, changedFilters, setChangedFilters, setSelectedFilters, isLastItem, setSaveFilters} = props;
    const { t } = useTranslation();
    const filterContext = useFilterPreference();
    
    const getFilterName = (name) => {
        switch (name) {
            case t('filters.routes.title'):
                return "changedRouteFilters";
            case t('filters.dateTime.title'):
                return "changedDateFilter";
            case t('filters.creditPayEfficiency.title'):
                return "changedCpeFilter";
            case t('filters.other.title'):
                return "changedOthersFilter";
        }
    }

    const getFilterModifiedCount = () => {
        let changedFilterName = getFilterName(filterName) || "";
        if (!changedFilterName) {
            return 0;
        }
        let filterModifiedCount = 0;
        for (let propName in changedFilters[changedFilterName]) {
            if (changedFilters[changedFilterName][propName] === true) {
                filterModifiedCount++;
            }
        }
        return filterModifiedCount;
    }
    const filterModifiedCount = getFilterModifiedCount();


    const clearModifiedFilter = () => {
        let changedFilterName = getFilterName(filterName) || "";
        let setInitialFilter = pairingPackageInitialFilter();
        for (let propName in changedFilters[changedFilterName]) {
            changedFilters[changedFilterName][propName] = false;
        }
        setChangedFilters((prev) => {
            return {
                ...prev,
                ...changedFilters
            }
        });

        if (t('filters.routes.title') === filterName) {
            setSelectedFilters((prevState) => {
                return {
                    ...prevState,
                    selectedRouteFilters: setInitialFilter.selectedRouteFilters
                }
            });
        } else if (t('filters.dateTime.title') === filterName) {
            setSelectedFilters((prevState) => {
                return {
                    ...prevState,
                    selectedDateFilter: setInitialFilter.selectedDateFilter
                }
            });
        }
        else if (t('filters.creditPayEfficiency.title') === filterName) {
            setSelectedFilters((prevState) => {
                return {
                    ...prevState,
                    selectedCpeFilter: setInitialFilter.selectedCpeFilter
                }
            });   
        }
        else if (t('filters.other.title') === filterName) {
            setSelectedFilters((prevState) => {
                return {
                    ...prevState,
                    selectedOthersFilter: setInitialFilter.selectedOthersFilter
                }
            }); 
        }
        if(filterContext.defaultSearchState) setSaveFilters(true); 
    }

    return (
        <div className='filter-container'>
            <div className="filter-container-head">
                <h3 className="filter-container-label">{filterName}{filterModifiedCount > 0 ? <span className="filter-container-head-clear" onClick={clearModifiedFilter}>{t('filters.clearLink')} {filterModifiedCount} {filterModifiedCount < 2 ? t('filters.filterLink1') : t('filters.filterLinkMore')}</span> : ""}</h3>
                
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={isOpen}
                            icon={<AddCircleIcon fontSize="large" className="iconAdd" />}
                            checkedIcon={<RemoveCircleOutlineOutlinedIcon className='iconRemove' />}
                            onChange={handleClick}
                            name='filter-container-checkbox'
                            />
                    }
                    label={ '' }
                />  
            </div>

             <div className="filter-container-content">
                 <Collapse in={isOpen} unmountOnExit={false}>
                    { props.children }
                 </Collapse>
             </div>
             <div className={isLastItem ? 'filter-container-no-divider' : 'filter-container-divider'} />
        </div>
    )
}
